import { GCModuleEnum } from '@business/constants/permissions';
import { LabelNameEnum } from '@business/entities/label';
import { OrgId, OrgResponse } from '@business/entities/organization';
import { PermissionService } from '@business/services/permission_service';
import { PermissionProvider } from '@core/components/PermissionProvider';
import { useRouteParam } from '@core/router';
import { useAccountSettings } from '@core/utils/hooks/misc/useSettings';
import { useObservable } from '@core/utils/hooks/rxjs';
import React, { memo } from 'react';
import { OrganizationPageBloc } from '../../OrganizationPageBloc';
import { Addresses } from './Addresses';
import { Orders } from './Orders';
import { OrgProjects } from './OrgProjects';
import { OrgSubscriptions } from './OrgSubscriptions';
import { PaymentMethods } from './PaymentMethods';
import { Sales } from './Sales';
import { TimeMaterialsList } from './TimeMaterialsList';

export interface BillingCardProps {
  bloc: OrganizationPageBloc;
  orgId?: OrgId;
  isModal?: boolean;
}
export const BillingCard = memo((props: BillingCardProps) => {
  const { bloc, isModal } = props;
  const orgId = props.orgId || useRouteParam('id');
  const organization = useObservable(bloc.organization$) as OrgResponse;
  const accountSettings = useAccountSettings();
  const vipRestricted = PermissionService.useVipRestricted(organization);

  if (!organization) return null;
  if (!organization.subscriptions) return null;
  if (!organization.invoices) return null;

  return (
    <React.Fragment>
      <div id="billing-card">
        <Addresses bloc={bloc} orgId={orgId} ordersActive={accountSettings.orders} />
        <PaymentMethods bloc={bloc} orgId={orgId} />
        <PermissionProvider module={GCModuleEnum.orders} label={LabelNameEnum.orders}>
          {accountSettings.orders && <Orders isModal={isModal} orgId={orgId} organization={organization!} />}
        </PermissionProvider>

        <PermissionProvider module={GCModuleEnum.timeMaterial} label={LabelNameEnum.timeMaterial}>
          {accountSettings.timeMaterials && !vipRestricted && (
            <TimeMaterialsList methods={organization.methods} isModal={isModal} orgId={orgId} organization={organization!} />
          )}
        </PermissionProvider>

        <PermissionProvider module={GCModuleEnum.projects} label={LabelNameEnum.projects}>
          <OrgProjects
            isModal={isModal}
            orgId={orgId}
            projects={organization!.projects}
            bloc={bloc}
            canProcess={organization && organization.methods ? !!organization!.methods.length : false}
            methods={organization && organization.methods ? organization!.methods : []}
            organization={organization!}
          />
        </PermissionProvider>
        <OrgSubscriptions
          isModal={isModal}
          orgId={orgId}
          subscriptions={organization!.subscriptions}
          bloc={bloc}
          canProcess={organization && organization.methods ? !!organization!.methods.length : false}
          methods={organization && organization.methods ? organization!.methods : []}
          organization={organization}
        />
        {/* <UnpaidInvoices organization={organization!} bloc={bloc} /> */}
        <Sales organization={organization} bloc={bloc} />
      </div>
    </React.Fragment>
  );
});
